import * as React from 'react';
import Error403 from "./403error";
import Error404 from "./404error";
import Error500 from "./500error";

export default class ErrorScreen extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        switch (this.props.status) {
            case 403:
                return <Error403 {...this.props} />;
            case 404:
                return <Error404 {...this.props}/>;
            case 500:
                return <Error500 {...this.props}/>;
            case 503:
                return <Error500 {...this.props} status ={this.props.status}/>;
            case 501:
                return <Error404 {...this.props} status ={this.props.status}/>;
            default:
                return '';
        }
    }
}
